import { render, staticRenderFns } from "./Cania.vue?vue&type=template&id=6b5bf5bf&"
import script from "./Cania.vue?vue&type=script&lang=js&"
export * from "./Cania.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports